import React from "react";
import { QR_COLUMN_LABELS, QR_COL_WIDTHS } from "../constants";

const colW = (w?: number) => (w == null ? {} : { width: w });

// Gray column header strip. Full bleed via -mx-4 md:-mx-8 so the gray
// background reaches the card's inner edges on both sides, matching Chart of
// accounts and Bank History. Rendered as its own component so the page shell
// can put it inside a position:sticky block alongside the report header and
// toolbar.
export default function QuickReportColumnHeader() {
  return (
    <div
      className="hidden md:block -mx-4 md:-mx-8"
      style={{ background: "#ECF0F4", borderTop: "1px solid #D8DEE6", borderBottom: "1px solid #D8DEE6" }}
    >
      <div className="px-4 md:px-8">
        <table className="w-full border-collapse" style={{ tableLayout: "fixed" }}>
          <colgroup>
            <col style={colW(QR_COL_WIDTHS.distributionAccount)} />
            <col style={colW(QR_COL_WIDTHS.date)} />
            <col style={colW(QR_COL_WIDTHS.type)} />
            <col style={colW(QR_COL_WIDTHS.refNo)} />
            <col />
            <col />
            <col style={colW(QR_COL_WIDTHS.accountName)} />
            <col style={colW(QR_COL_WIDTHS.cleared)} />
            <col style={colW(QR_COL_WIDTHS.amount)} />
            <col style={colW(QR_COL_WIDTHS.balance)} />
          </colgroup>
          <thead>
            <tr>
              <th className="py-2.5 px-3 text-left text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.distributionAccount}</th>
              <th className="py-2.5 px-3 text-left text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.date}</th>
              <th className="py-2.5 px-3 text-left text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.type}</th>
              <th className="py-2.5 px-3 text-left text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.refNo}</th>
              <th className="py-2.5 px-3 text-left text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.payee}</th>
              <th className="py-2.5 px-3 text-left text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.description}</th>
              <th className="py-2.5 px-3 text-left text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.accountName}</th>
              <th className="py-2.5 px-3 text-left text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.cleared}</th>
              <th className="py-2.5 px-3 text-right text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.amount}</th>
              <th className="py-2.5 px-3 text-right text-[10.5px] font-bold text-ink2 uppercase tracking-wider">{QR_COLUMN_LABELS.balance}</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );
}